import { ModelIlluminationData } from '../modelIllumination/modelIlluminationData';
import { Vector } from '../types/vector/vector';

export class DefaultModelIlluminationData {

  private static getCssVar(name: string): string | undefined {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const value = getComputedStyle(document.documentElement)
      .getPropertyValue(name)
      .trim()
      .replace(/^["']|["']$/g, '');

    return value.length > 0 ? value : undefined;
  }

  private static getCssNumber(
    name: string,
    defaultValue: number,
  ): number {
    const value = DefaultModelIlluminationData.getCssVar(name);
    if (value === undefined) {
      return defaultValue;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : defaultValue;
  }

  private static getCssVector(
    name: string,
    defaultValue: Vector,
  ): Vector {
    const value = DefaultModelIlluminationData.getCssVar(name);
    if (value === undefined) {
      return defaultValue;
    }

    const parts = value
      .split(/\s+/)
      .map((part) => Number(part));

    if (parts.length !== 3 || parts.some((part) => !Number.isFinite(part))) {
      return defaultValue;
    }

    return new Vector(parts[0], parts[1], parts[2]);
  }

  static get() : ModelIlluminationData {
    const lightsConfig = new ModelIlluminationData();

    lightsConfig.lights = [
      {
        name: 'topDown',
        direction: DefaultModelIlluminationData.getCssVector(
          '--viewer-light1-direction',
          new Vector(-1, -1, -1),
        ),
        position: new Vector(200, 400, 200),
        intensity: DefaultModelIlluminationData.getCssNumber(
          '--viewer-light1-intensity',
          5,
        ),
        castShadows: true,
        shadowDarkness: 0.0,
      },
      {
        name: 'Back',
        direction: DefaultModelIlluminationData.getCssVector(
          '--viewer-light2-direction',
          new Vector(1, -4, 2),
        ),
        position: new Vector(-2, 30, -10),
        intensity: DefaultModelIlluminationData.getCssNumber(
          '--viewer-light2-intensity',
          5.0,
        ),
        castShadows: true,
        shadowDarkness: 0.05,
      },
      {
        name: 'downTop',
        direction: DefaultModelIlluminationData.getCssVector(
          '--viewer-light3-direction',
          new Vector(1, 2, -1),
        ),
        position: new Vector(-200, -400, -200),
        intensity: DefaultModelIlluminationData.getCssNumber(
          '--viewer-light3-intensity',
          0.6,
        ),
        castShadows: true,
        shadowDarkness: 0.0,
      },
      {
        name: 'downTop2',
        direction: DefaultModelIlluminationData.getCssVector(
          '--viewer-light4-direction',
          new Vector(1, 2, 1),
        ),
        position: new Vector(-200, -200, -200),
        intensity: DefaultModelIlluminationData.getCssNumber(
          '--viewer-light4-intensity',
          0.6,
        ),
        castShadows: true,
        shadowDarkness: 0.0,
      },
    ];

    lightsConfig.environmentIntensity = DefaultModelIlluminationData.getCssNumber(
      '--viewer-environment-intensity',
      0.8,
    );

    return lightsConfig;
  }
}
